<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'expenseEdit',
    components: {
      baseEdit,
    },
  };
</script>
